module.exports = __webpack_public_path__ + "img/carbon_sources.2ab3fa73.png";